import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { useSites } from 'hooks/sites/useSites';
import { useCollectionPoints } from 'hooks/useCollectionPoints';

import { washHub } from 'store/slices';

import { createCustomer } from 'api/customers';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import { RefType, AddCustomerModalProps } from './AddCustomerModal.props';

import AddCustomerModalView from './AddCustomerModal.view';

const Container = forwardRef<RefType, AddCustomerModalProps>((_, ref) => {
  const queryClient = useQueryClient();
  const washHubs = washHub.selectors.useAllWashHubs();
  const washHubId = washHub.selectors.useSelectedWashHubId();

  const { data: sites = [], isLoading } = useSites();
  const { data = [], isLoading: isLoadingPoints } = useCollectionPoints();

  const { isOpen, onOpen, onClose } = useDisclosure();

  useImperativeHandle(
    ref,
    () => ({
      onOpen,
    }),
    [onOpen],
  );

  const { mutate, isLoading: isCreating } = useMutation(createCustomer, {
    onSuccess: () => {
      successToast('Customer Created Successfully');

      queryClient.invalidateQueries(`fetch-customers-${washHubId}`);

      queryClient.invalidateQueries(`fetch-customers-${washHubId}-select`, {
        exact: true,
      });

      onClose();
    },
  });

  const _props = {
    isOpen,
    onClose,
    washHubs,
    isCreating,
    // sites,
    // collectionPoints: data,
    isLoadingSites: isLoading,
    isLoadingPoints,
    onCreate: async (payload: any) => {
      payload = {
        ...payload,
        washHub: washHubId,
        billingContact: !!payload?.billingContact
          ? payload?.billingContact
          : undefined,
        // washHubCode: washHubId,
        // siteCode: sites?.find((s) => s._id === payload.site)?.code,
        // collectionPointCode: data?.find(
        //   (c) => c._id === payload.collectionPoint,
        // )?.code,
      };

      mutate(payload);
    },
  };

  return <AddCustomerModalView {..._props} />;
});

const AddCustomerModal = memo(Container);

export default AddCustomerModal;
